import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classnames from 'classnames';
import { EditorialRatingsEntities } from 'client/data/models/editorial-review';
import { getModelSectionMap } from 'site-modules/shared/utils/core-page/editorial-review';

export function EditorialReviewRating({ ratings, isScorecardV4, className, params }) {
  const modelSectionMap = getModelSectionMap({ params, isScorecardV4 });

  if (modelSectionMap.every(({ key }) => !get(ratings, `[${key}].rating`))) {
    return null;
  }

  return (
    <ul className={classnames('list-unstyled m-0', className)}>
      {modelSectionMap.map(({ name, key }) => (
        <li key={key} className="d-flex justify-content-between py-0_25">
          <span className={classnames({ 'text-capitalize': !isScorecardV4 })}>{isScorecardV4 ? name : key}&nbsp;</span>
          <span className="text-end">{get(ratings, `[${key}].rating`, 'N/A')}</span>
        </li>
      ))}
    </ul>
  );
}

EditorialReviewRating.propTypes = {
  ratings: EditorialRatingsEntities,
  params: PropTypes.shape({
    isTruck: PropTypes.bool,
    isElectric: PropTypes.bool,
    isPluginHybrid: PropTypes.bool,
  }),
  className: PropTypes.string,
  isScorecardV4: PropTypes.bool,
};

EditorialReviewRating.defaultProps = {
  ratings: null,
  params: null,
  className: null,
  isScorecardV4: false,
};
